export const ROUTE_PATH = {
  OCEAN_TRACKING: '/ocean-shipments/tracking',
  OCEAN_TRACK_BY_GROUP: '/ocean-shipments/tracking-by-group',
  ROAD_TRACKING: '/road-shipments/tracking',
  AIR_TRACKING: '/air-shipments/tracking',
  OL_TRACKING: '/outsourced-logistics/tracking',
  VESSEL_SCHEDULE: '/vessel-schedules',
  FLIGHT_SCHEDULE: '/flight-schedules',
  LOCATIONS: '/locations',
  FLOW_ORDERS: '/orders',
  STORAGE_COST: '/dnd-cost',
  PARTNERS_MANAGEMENT: '/partners',
  VEHICLE_MASTER: '/vehicleMaster',
  ADD_SINGLE_ROAD_SHIPMENT: 'add-shipments/TRUCK_SHIPMENT',
  SIGNUP_VERIFY: '/verify/:verificationCode',
  CONFIGURE_PRIORITISATION: '/configure-prioritisation',
  DASHBOARD: "/ct/dashboard_v2",
  TRIPS: "/ct/trips",
  STOPS: "/ct/stops",
  ORDERS: "/ct/orders",
  PARENT_ORDERS: "/ct/parent-orders_v2",
  INTEGRATION_ISSUES: "/ct/integrated-issues",
  EXCEPTIONS: "/ct/exceptions_v2",
  RULEBOOK: '/rulebook',
};

export const ROUTE_REFERER = {
  DASHBOARD_OCEAN: 'DashOean',
  DASHBOARD_ROAD: 'DashRoad',
  DASHBOARD_AIR: 'DashAir',
  DASHBOARD_SUMMARY: 'DashSummary',
  CALENDAR_OCEAN: 'CalOcean',
  CALENDAR_ROAD: 'CalRoad',
  CALENDAR_AIR: 'CalAir',
  UPLOAD_HISTORY: 'uploadHistory',
};

const migrateRouteBasePath = 'cargoes/flow/';
export const MIGRATE_ROUTES = {
  OCEAN_TRACKING: `${migrateRouteBasePath}shipment/ocean`,
  VESSEL_SCHEDULE: `${migrateRouteBasePath}schedules/vessel`,
  FLIGHT_SCHEDULE: `${migrateRouteBasePath}schedules/flight`,
  LOCATIONS: `${migrateRouteBasePath}locations`,
  STORAGE_COST: `${migrateRouteBasePath}dnd-cost`,
  PARTNERS_MANAGEMENT: `${migrateRouteBasePath}partners`,
  VEHICLE_MASTER: `${migrateRouteBasePath}vehicleMaster`,
  SIGN_UP_SET_COMPANY: `${migrateRouteBasePath}signup?set-company=true`,
  SIGNUP: `${migrateRouteBasePath}signup`,
  ADD_SINGLE_ROAD_SHIPMENT: `${migrateRouteBasePath}add-shipment/truck/add`,
  CONFIGURE_PRIORITISATION: `${migrateRouteBasePath}configure-prioritisation`,
  ORDERS: `cargoes/orders`,
  RULEBOOK: `cargoes/rulebook`,
};